import { CardContent } from '@pocketlaw/tetris';
import { motion } from 'motion/react';
import styled from 'styled-components';
export const WidgetBody = styled(CardContent) `
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
export const AnimateHeightContainer = styled(motion.div).attrs((props) => ({
    animate: {
        height: props.$isOpen ? 'auto' : 0,
    },
    initial: false,
    transition: {
        duration: 0.2,
    },
})) `
  display: block;
  overflow: hidden;
`;
